import {
    FETCH_ADMIN_SLIDE_EDIT_REQUEST,
    FETCH_ADMIN_SLIDE_EDIT_SUCCESS,
    FETCH_ADMIN_SLIDE_EDIT_FAILURE,
  } from "./actionTypes";
  
  import { AdminSlideEditActions, AdminSlideEditState } from "./types";
  
  const initialState: AdminSlideEditState = {
    loading: false,
    result: null,
    error: null,
  };
  
  export default (state = initialState, action: AdminSlideEditActions) => {
    switch (action.type) {
      case FETCH_ADMIN_SLIDE_EDIT_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case FETCH_ADMIN_SLIDE_EDIT_SUCCESS:
        return {
          ...state,
          loading: false,
          result: action.payload.result,
          error: null,
        };
      case FETCH_ADMIN_SLIDE_EDIT_FAILURE:
        return {
          ...state,
          loading: false,
          result: [],
          error: action.payload.error,
        };
      default:
        return {
          ...state,
        };
    }
  };